import { useState } from 'react';
import { Search, FileText, Building2 } from 'lucide-react';
import { MfrImg, openAsset } from '../lib/mfrAssets';
import { useMfrs, matchProducts, prodOf, showProducts, setShowProducts } from '../lib/mfr';

// lists manufacturer products of the same kind/design as a catalogue item
export default function ProductChooser({ t, item, current, onChoose, testid = 'prod-chooser' }) {
  const mf = useMfrs();
  const [show, setShow] = useState(showProducts);
  const [q, setQ] = useState('');
  const all = matchProducts(item, mf);
  const list = all.filter((x) => !q || `${x.mfr} ${x.name} ${x.dim} ${x.mat}`.toLowerCase().includes(q.toLowerCase()));
  const toggle = () => { setShowProducts(!show); setShow(!show); };
  return (
    <div className="prod-chooser" data-testid={testid}>
      <label className="prod-toggle"><input type="checkbox" data-testid={`${testid}-toggle`} checked={show} onChange={toggle} /> <Building2 size={14} /> {t.pcShow} ({all.length})</label>
      {show && <>
        {all.length > 6 && <label className="cat-search prod-search"><Search size={14} /><input data-testid={`${testid}-search`} value={q} placeholder={t.mfSearch} onChange={(e) => setQ(e.target.value)} /></label>}
        <div className="mfr-list">
          {list.map((x) => (
            <button key={`${x.mfrId}-${x.id}`} className={`mfr-item prod-item ${current?.ref === x.id ? 'on' : ''}`} data-testid={`${testid}-item-${x.id}`} onClick={() => onChoose(prodOf(x))}>
              {x.img ? <MfrImg src={x.img} /> : <i className="fs-dot" style={{ background: '#64748b' }} />}
              <span className="mfr-item-txt"><b>{x.name}</b><small>{[x.mfr, x.dim, x.mat, x.sku].filter(Boolean).join(' · ')}</small></span>
              {x.pdf && /^https?:/i.test(x.pdf) && <a className="icon-btn" href={x.pdf} target="_blank" rel="noreferrer" onClick={(e) => openAsset(x.pdf, e)} title={t.mfDatasheet}><FileText size={14} /></a>}
            </button>
          ))}
          {!all.length && <div className="empty" data-testid={`${testid}-none`}>{t.pcNone}</div>}
        </div>
      </>}
      <button className="btn btn-outline btn-sm" data-testid={`${testid}-generic`} onClick={() => onChoose(null)}>{t.pcGeneric}</button>
    </div>
  );
}
